const Main = () => import('./Main')
const Program = () => import('@/components/Creativity/Program')
const TalkSymposium = () => import('@/components/Creativity/TalkSymposium')
const SchoolOfCreativity = () => import('@/components/Creativity/SchoolOfCreativity')
const SchoolOfCreativityDetail = () => import('@/components/Creativity/SchoolOfCreativityDetail')
const Detail = () => import('@/components/Creativity/Parts/Detail')

const route = {
  path: '/creativity',
  name: 'creativity',
  meta: {
    title: 'Creativity Day - A D M A N 2 0 1 9'
  },
  component: Main,
  children: [
    {
      path: 'program',
      name: 'creativity_program',
      meta: {
        title: 'Creativity Day - A D M A N 2 0 1 9'
      },
      components: {
        mainCreativity: Program
      }
    },
    {
      path: 'talk_symposium',
      name: 'creativity_talk_symposium',
      meta: {
        title: 'Creativity Day - A D M A N 2 0 1 9'
      },
      props: true,
      components: {
        mainCreativity: TalkSymposium
      },
      children: [
        {
          path: ':id',
          name: 'creativity_talk_symposium_detail',
          meta: {
            title: 'Creativity Day - A D M A N 2 0 1 9'
          },
          props: true,
          components: {
            talkSymposiumDetail: Detail
          }
        }
      ]
    },
    {
      path: 'school_of_creativity',
      name: 'creativity_school_of_creativity',
      meta: {
        title: 'Creativity Day - A D M A N 2 0 1 9'
      },
      components: {
        mainCreativity: SchoolOfCreativity
      },
      children: [
        {
          path: ':mainId :detailId',
          name: 'creativity_school_of_creativity_detail',
          meta: {
            title: 'Creativity Day - A D M A N 2 0 1 9'
          },
          components: {
            schoolsDetail: SchoolOfCreativityDetail
          }
        }
        // {
        //   path: ':id',
        //   name: 'creativity_school_of_creativity_time',
        //   meta: {
        //     title: 'Creativity Day - A D M A N 2 0 1 9'
        //   },
        //   components: {
        //     Detail: Detail
        //   },
        //   children: [
        //     {
        //       path: ':idDetail',
        //       name: 'creativity_school_of_creativity_detail',
        //       components: {
        //         schoolsDetail: Detail
        //       }
        //     }
        //   ]
        // }
      ]
    }
  ]
}

export default route
